/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-body-spacing',
  templateUrl: './theme-option-tooltips-body-spacing.component.html',
  styleUrls: ['./theme-option-tooltips-body-spacing.component.css']
})
export class ThemeOptionTooltipsBodySpacingComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_bodySpacing';

  constructor() {}

  receiveValue(value: string) {
    this.themeOptions.setOption('tooltips_bodySpacing', value);
  }

}
